import { Link, useLocation } from "react-router-dom";

function SideMenu(props) {
  const menu = props.kitchens.map((kitchen) => {
    const parts = kitchen.name.split(" ");
    const short =
      parts.length === 1
        ? parts[0].substring(0, 2)
        : `${parts[0][0]}${parts[1][0]}`;
    return {
      id: kitchen.uuid,
      text:
        props.currentUser?.roles?.includes("ADMIN") && kitchen.stripe_account_id
          ? `${kitchen.name} (${kitchen.stripe_account_id})`
          : kitchen.name,
      short: short.toUpperCase(),
      kitchen,
    };
  });

  const submenu = [
    {
      href: "/welcome",
      text: "Welcome",
    },
    {
      href: "/faq",
      text: "FAQs",
    },
    {
      href: "/payments",
      text: "Payments",
    },
    {
      href: "/orders",
      text: "Orders",
    },
    {
      href: "/dishes",
      text: "Dishes",
    },
    {
      href: "/settings",
      text: "Settings",
    },
    {
      href: "/login",
      text: "Log out",
    },
  ];

  const kitchenIsSelected = (id) => id === props.selectedKitchen?.uuid;

  let { pathname } = useLocation();

  return (
    <nav className="sidebar-wrapper">
      <div className="sidebar-tabs">
        <div className="nav" role="tablist" aria-orientation="vertical">
          <a href="/" className="logo">
            <img src="/assets/img/logo.png" alt="Fale" />
          </a>

          {menu.map((tab) => (
            <Link
              key={tab.id}
              className={`nav-link ${kitchenIsSelected(tab.id) ? "active" : ""
                }`}
              data-bs-toggle="tab"
              role="tab"
              aria-controls="tab-home"
              aria-selected="true"
              onClick={() => {
                props.setSelectedKitchen(tab.kitchen);
              }}
            >
              <span
                style={{
                  color: "red",
                  fontSize: "18px",
                  padding: "0",
                  textAlign: "center",
                }}
              >
                {tab.short}
              </span>
              <span className="nav-link-text">{tab.text}</span>
            </Link>
          ))}
        </div>
        {submenu && (
          <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="tab-home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="tab-pane-header">
                {props.selectedKitchen?.name}
              </div>

              <div className="sidebarMenuScroll">
                <div className="sidebar-menu">
                  <ul>
                    {submenu.map((item) => (
                      <li key={item.text}>
                        <Link
                          className={
                            item.href === pathname ? "current-page" : ""
                          }
                          to={item.href}
                        >
                          {item.text}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default SideMenu;
